"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _common = require("@/mixins/common");
var _createModel = _interopRequireDefault(require("./components/createModel"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AppVersion',
  components: {
    CreateModel: _createModel.default
  },
  mixins: [_common.common],
  provide: function provide() {
    return {
      appParent: this
    };
  },
  data: function data() {
    return {
      pageName: 'appVersion',
      loadingComponent: null,
      isLoading: false,
      list: [],
      iosList: {},
      androidList: {},
      total: 0,
      currPage: 1,
      limit: 10,
      isShowHisModel: false,
      isShowModel: false,
      currBrand: 'ANDROID',
      dialogStatus: 'create',
      form: {
        appVersionInfoPk: '',
        appPlatformType: '',
        displayVersion: '',
        appBizType: 'SFE',
        downloadUrl: '',
        versionDesc: ''
      },
      initForm: {
        appVersionInfoPk: '',
        appPlatformType: '',
        displayVersion: '',
        appBizType: 'SFE',
        downloadUrl: '',
        versionDesc: ''
      },
      hisList: [],
      appPlatformTypeList: [{
        valueCode: 'IOS',
        valueName: 'IOS'
      }, {
        valueCode: 'ANDROID',
        valueName: 'ANDROID'
      }],
      appBizTypeList: [{
        valueCode: 'SFE',
        valueName: 'SFE'
      }],
      keyMap: {
        appPlatformType: this.$t('sfe.appVersion.table.appPlatformType'),
        displayVersion: this.$t('sfe.appVersion.table.displayVersion'),
        appBizType: this.$t('sfe.appVersion.table.appBizType'),
        downloadUrl: this.$t('sfe.appVersion.table.downloadUrl'),
        versionDesc: this.$t('sfe.appVersion.table.versionDesc')
      },
      IOS_url: 'https://itunes.apple.com/app'
    };
  },
  computed: {
    currentVersion: function currentVersion() {
      return function (platform, biz) {
        if (platform === 'IOS') {
          return {
            displayVersion: this.iosList[biz] && this.iosList[biz].displayVersion,
            versionStatus: this.iosList[biz] && this.iosList[biz].versionStatus
          };
        } else if (platform === 'ANDROID') {
          return {
            displayVersion: this.androidList[biz] && this.androidList[biz].displayVersion,
            versionStatus: this.androidList[biz] && this.androidList[biz].versionStatus
          };
        } else {
          return {
            displayVersion: '',
            versionStatus: ''
          };
        }
      };
    },
    keyMapping: function keyMapping() {
      return function (val) {
        return this.keyMap[val] || val;
      };
    }
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  mounted: function mounted() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: (0, _objectSpread2.default)({}, this.searchVal)
      };
      this.isLoading = true;
      this.$api.appVersion.getList(param).then(function (res) {
        _this.isLoading = false;
        _this.list = res.data.items;
        _this.total = res.data.totalCount;
        _this.list.forEach(function (item) {
          if (item.appPlatformType === 'IOS') {
            _this.$set(_this.iosList, item.appBizType, item);
          } else if (item.appPlatformType === 'ANDROID') {
            _this.$set(_this.androidList, item.appBizType, item);
          }
        });
      }).catch(function (err) {
        console.log(err);
        _this.isLoading = false;
      });
    },
    checkHistory: function checkHistory(platform, biz) {
      var _this2 = this;
      var id = '';
      if (platform === 'IOS') {
        id = this.iosList[biz].appVersionInfoPk;
      } else if (platform === 'ANDROID') {
        id = this.androidList[biz].appVersionInfoPk;
      } else {
        id = '';
      }
      if (!id) return;
      this.isLoading = true;
      this.$api.appVersion.getHisList(id).then(function (res) {
        _this2.isLoading = false;
        _this2.hisList = res.data;
        _this2.dialogStatus = 'checkAuthDetail';
        _this2.$nextTick(function () {
          _this2.isShowHisModel = true;
        });
      }).catch(function (err) {
        console.log(err);
        _this2.isLoading = false;
      });
    },
    resetForm: function resetForm(platform, biz) {
      this.form = {
        appVersionInfoPk: '',
        appPlatformType: platform,
        displayVersion: '',
        appBizType: biz,
        downloadUrl: platform === 'IOS' ? this.IOS_url : '',
        versionDesc: ''
      };
      this.initForm = {
        appVersionInfoPk: '',
        appPlatformType: platform,
        displayVersion: '',
        appBizType: biz,
        downloadUrl: platform === 'IOS' ? this.IOS_url : '',
        versionDesc: ''
      };
    },
    addVersion: function addVersion(platform, biz) {
      var _this3 = this;
      this.dialogStatus = 'create';
      this.currBrand = platform;
      this.resetForm(platform, biz);
      this.$nextTick(function () {
        _this3.isShowModel = true;
      });
    },
    clearCache: function clearCache() {
      var _this4 = this;
      this.$confirm('', this.$t('sfe.appVersion.dialog.content2'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        center: true,
        lockScroll: false,
        customClass: 'confirm-box'
      }).then(function () {
        _this4.$api.appVersion.clearUserCache().then(function (res) {
          _this4.isLoading = false;
          _this4.$message.success(_this4.$t('sfe.appVersion.dialog.releaseSuccess'));
          _this4.fetchData();
        }).catch(function (err) {
          console.log(err);
          _this4.isLoading = false;
        });
      }).catch(function (e) {
        console.log(e);
      });
    },
    releaseVersion: function releaseVersion(platform, biz) {
      var _this5 = this;
      if (!this.hasPermission(this.pageName, 'RELEASE')) return;
      var _this$currentVersion = this.currentVersion(platform, biz),
        displayVersion = _this$currentVersion.displayVersion,
        versionStatus = _this$currentVersion.versionStatus;
      if (versionStatus !== 'DRAF') return;
      this.$confirm("".concat(platform, "-").concat(biz, "-").concat(displayVersion), this.$t('sfe.appVersion.dialog.content1'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        center: true,
        lockScroll: false,
        customClass: 'confirm-box'
      }).then(function () {
        _this5.submitRelease(platform, biz);
      }).catch(function (e) {
        console.log(e);
      });
    },
    submitRelease: function submitRelease(platform, biz) {
      var _this6 = this;
      var id = '';
      if (platform === 'IOS') {
        id = this.iosList[biz].appVersionInfoPk;
      } else if (platform === 'ANDROID') {
        id = this.androidList[biz].appVersionInfoPk;
      } else {
        id = '';
      }
      if (!id) return;
      this.isLoading = true;
      this.$api.appVersion.releaseApp(id).then(function (res) {
        _this6.isLoading = false;
        _this6.$message.success(_this6.$t('sfe.appVersion.dialog.releaseSuccess'));
        _this6.fetchData();
      }).catch(function (err) {
        console.log(err);
        _this6.isLoading = false;
      });
    }
  }
};